import { computed } from 'vue';
import { AuditorCampaignManagementAPIClient } from '@studyportals/campaign-management-api-interface';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import { LoadingStatuses } from '@/models/loading.interface';
import { CampaignFeaturesForTracking } from '@/models/tracking.interface';
import cookieHandler from '@/infrastructure/cookie-handler';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';
import redshiftTracker from '@/infrastructure/redshift-tracker';

class AuditorPresenter {
	private client: AuditorCampaignManagementAPIClient;
	private readonly tokenId: string;

	private campaignId = computed((): number => {
		const router = store.getters.router();
		return router.props.id;
	});

	constructor() {
		this.client = new AuditorCampaignManagementAPIClient(webpackDefinitions.CAMPAIGN_MANAGEMENT_API_URL);
		this.tokenId = cookieHandler.retrieveTokenIdCookie();
	}

	public async retrieveAuditorEntries(): Promise<void> {
		if (!this.campaignId.value) {
			store.mutations.setModalErrorState(ModalErrorStates.INVALID_CAMPAIGN_ID);
			return;
		}

		store.mutations.setLoadingStatusAuditorEntries(LoadingStatuses.ACTIVE);

		let wasSuccessful = false;
		try {
			const entries = await this.client.getCampaignAuditorData(this.campaignId.value, this.tokenId);
			store.mutations.setAuditorEntries(entries);
			store.mutations.setLoadingStatusAuditorEntries(LoadingStatuses.INACTIVE);
			wasSuccessful = true;
		} catch (e) {
			rollbarOperator.triggerError(e as Error);
			store.mutations.setModalErrorState(ModalErrorStates.GET_AUDITOR_ENTRIES);
			store.mutations.setLoadingStatusAuditorEntries(LoadingStatuses.FAILURE);
		} finally {
			redshiftTracker.trackProcessOutcome(CampaignFeaturesForTracking.AUDITOR, false, wasSuccessful);
		}
	}
}

export default new AuditorPresenter();
